export interface LNavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: LNavigationRoute[]
}

const filterRoutesByRole = (routes: LNavigationRoute[], role: string): LNavigationRoute[] => {
  return routes
    .filter((route) => {
      // Check if the route has allowed roles, and if the user's role is allowed
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true // Accessible by the user's role
      }
      // Fallback condition for routes without role restrictions (e.g., dashboard)
      if (!route.meta.allowedRoles) {
        return true // Accessible by everyone
      }
      return false // Hide route if not allowed for the user's role
    })
    .map((route) => {
      // Recursively filter children routes if any
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Support Console',
      meta: {
        icon: 'support_agent',
        allowedRoles: ['support_agent'],
      },
      children: [
        {
          name: 'analytics',
          displayName: 'Support Analytics',
          meta: { icon: 'analytics', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'tickets',
      displayName: 'Ticket Management',
      meta: { icon: 'assignment', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'tickets',
          displayName: 'All Tickets',
          meta: { icon: 'assignment', allowedRoles: ['support_agent'] },
        },
        {
          name: 'ticket-management',
          displayName: 'Ticket Management',
          meta: { icon: 'manage_accounts', allowedRoles: ['support_agent'] },
        },
        {
          name: 'issues',
          displayName: 'Issues',
          meta: { icon: 'report_problem', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'drivers',
      displayName: 'Driver Support',
      meta: { icon: 'moped', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'drivers',
          displayName: 'Driver Issues',
          meta: { icon: 'moped', allowedRoles: ['support_agent'] },
        },
        {
          name: 'our-drivers',
          displayName: 'Our Drivers',
          meta: { icon: 'person', allowedRoles: ['support_agent'] },
        },
        {
          name: 'trips',
          displayName: 'Trip Support',
          meta: { icon: 'route', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'vehicles',
      displayName: 'Charging Support',
      meta: { icon: 'ev_station', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'vehicles',
          displayName: 'Vehicle Issues',
          meta: { icon: 'commute', allowedRoles: ['support_agent'] },
        },
        {
          name: 'our-vehicles',
          displayName: 'Our Vehicles',
          meta: { icon: 'directions_car', allowedRoles: ['support_agent'] },
        },
        {
          name: 'bikes',
          displayName: 'Bikes',
          meta: { icon: 'two_wheeler', allowedRoles: ['support_agent'] },
        },
        {
          name: 'maintenance',
          displayName: 'Charging Issues',
          meta: { icon: 'ev_station', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'messages',
      displayName: 'Customer Chat',
      meta: { icon: 'message', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'messages',
          displayName: 'Inbound Chat',
          meta: { icon: 'message', allowedRoles: ['support_agent'] },
        },
        {
          name: 'alarms',
          displayName: 'Alerts',
          meta: { icon: 'notifications', allowedRoles: ['support_agent'] },
        },
      ],
    },
    {
      name: 'reports',
      displayName: 'Support Reports',
      meta: { icon: 'assessment', allowedRoles: ['support_agent'] },
      children: [
        {
          name: 'reports',
          displayName: 'Resolution Reports',
          meta: { icon: 'assessment', allowedRoles: ['support_agent'] },
        },
        {
          name: 'analytics',
          displayName: 'Performance Analytics',
          meta: { icon: 'analytics', allowedRoles: ['support_agent'] },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['support_agent'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['support_agent'],
          },
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: { icon: 'manage_accounts', allowedRoles: ['support_agent'] },
    },
  ],
}

export default sidebarRoutes
